


























































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';

@Component({
  components: {
    NavigationEntryTemplate: () => import('./NavigationEntryTemplate.vue')
  }
})
export default class NavigationEntryTemplate extends Vue {
  @Prop() naviEntry!: DisguiseDto.NaviEntryDto<DisguiseDto.SimpleNaviTypeDtoUnion>;
  @Prop({
    default: false
  }) showFooterItemsOnly!: boolean;
  routeMatched: boolean = false;
  loadingStates: { [id: number]: boolean } = {};
  @Prop({
    default: () => {
      return {};
    }
  }) favorites!: { [id: number]: boolean };

  created() {
    // detect if the current route should be shown as active (expanded)
    let match = false;
    for (const currentRoute of this.$route.matched) {
      match = currentRoute.regex.test(this.naviEntry.fullPath || '');
      if (match) {
        break;
      }
    }
    this.routeMatched = match;
  }

  toggleFavorite(event: Event,
                 naviEntry: DisguiseDto.NaviEntryDto<DisguiseDto.SimpleNaviTypeDtoUnion>
  ) {
    if (naviEntry.canBeFavorite) {
      event.preventDefault();

      this.loadingStates = {
        ...this.loadingStates,
        [naviEntry.id || 0]: true
      };
      if (this.favorites[naviEntry.id || 0]) {
        this.$store.dispatch('deleteNaviFavorite', {naviEntry}).then(() => {
          this.loadingStates = {
            ...this.loadingStates,
            [naviEntry.id || 0]: false
          };
        }, () => {
          this.loadingStates = {
            ...this.loadingStates,
            [naviEntry.id || 0]: false
          };
          this.$store.commit('showSnack', {
            message: 'Fehler beim Datenaustausch',
            color: 'error'
          });
        });
      } else {
        this.$store.dispatch('addNaviFavorite', {naviEntry}).then(() => {
          this.loadingStates = {
            ...this.loadingStates,
            [naviEntry.id || 0]: false
          };
        }, () => {
          this.loadingStates = {
            ...this.loadingStates,
            [naviEntry.id || 0]: false
          };
          this.$store.commit('showSnack', {
            message: 'Fehler beim Datenaustausch',
            color: 'error'
          });
        });
      }
    }
  }
}
